import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum ADMIN_SOURCE_PAGE {
  NEW = "NEW",
  OLKY_PASS_PRO = "OLKY_PASS_PRO"
}

export const ADMIN_SLICE_INITIAL = {
  adminSourcePage: ADMIN_SOURCE_PAGE.NEW
} satisfies FlowState as FlowState;

type FlowState = {
  adminSourcePage: ADMIN_SOURCE_PAGE;
};

export const adminSlice = createSlice({
  name: "admin",
  initialState: ADMIN_SLICE_INITIAL,

  reducers: {
    setAdminSourcePage: (state, action: PayloadAction<ADMIN_SOURCE_PAGE>) => {
      state.adminSourcePage = action.payload;
    }
  }
});

export const { setAdminSourcePage } = adminSlice.actions;
